import React, {Fragment} from 'react';
import Box from '../layout/Box';
import TextInput from '../form/TextInput';
import CheckBox from '../form/CheckBox';
import Select from '../form/Select';
import SelectorGrid from '../form/SelectorGrid/SelectorGrid';
import {EditorField as Editor, defaultToolbar} from '../form/editor/editor';
import { UpdatedByFormatter } from '../../utils/formatters.js';
import createEditor from '../form/ComponentEditor';
import DateTimeInput from "../form/DateTimeInput";

class emailcampaignEditor extends React.Component {

    render() {
        const toolbar = [...defaultToolbar];
        const sortable = true;
        const filterable = true;
        return (
            <Fragment>
                <Box
                    theme="default">
                    <SelectorGrid
                        componentConfig={this.props.componentConfig}
                        columns={ {
                            id: {width:1, sortable},
                            name: {width:5, filterable, sortable},
                            start_date: {width:2, filterable, sortable},
                            end_date: {width:2, filterable, sortable},
                            updated_by: {width:2, sortable, renderer: UpdatedByFormatter}
                        } }
                        filter={[]}
                        pageSize={5}
                        orderBy={{field: this.props.componentConfig.idfield, direction: "DESC"}}
                        onSelectionChange={ (selection) => this.props.loadForm(selection.value) }
                        selection={this.props.selection}
                    />
                </Box>
                <Box
                    theme="default"
                    footer={[
                        <button key="0" type="button" disabled={ !this.props.dirty } className={ "btn pull-right btn-primary"+(this.props.dirty?"":" disabled")} onClick={ this.props.saveForm }>
                            Mentés
                        </button>,
                        <button key="1" type="button" className="btn pull-left btn-primary" onClick={ this.props.pristineForm }>
                            Új
                        </button>
                    ]}
                >
                    <form onSubmit={this.props.handleSubmit}>
                        <div className="box-body">
                            <div className="row form-row">
                                <div className="col-sm-1 col-sm-push-11">
                                    <TextInput
                                        name={this.props.componentConfig.idfield}
                                        value={this.props.values[this.props.componentConfig.idfield]}
                                        label="Kód"
                                        role="idfield"
                                    />
                                </div>
                                <div className="col-sm-11 col-sm-pull-1">
                                    <TextInput
                                        name="name"
                                        value={this.props.values.name}
                                        label="Név"
                                        saveChanges={this.props.setFieldValue}
                                    />
                                </div>
                            </div>
                            <div className="row form-row">
                                <div className="col-sm-6">
                                    <DateTimeInput
                                        name="start_date"
                                        value={this.props.values.start_date}
                                        label="Kezdés"
                                        showTime={true}
                                        saveChanges={this.props.setFieldValue}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <DateTimeInput
                                        name="end_date"
                                        value={this.props.values.end_date}
                                        label="Vég"
                                        showTime={true}
                                        saveChanges={this.props.setFieldValue}
                                    />
                                </div>
                            </div>
                            <div className="row form-row">
                                <div className="col-sm-12">
                                    <TextInput
                                        name="name"
                                        value={this.props.values.description}
                                        label="Leírás"
                                        saveChanges={this.props.setFieldValue}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </Box>
            </Fragment>
        );
    }
}
export default createEditor({componentName: "emailcampaign", WrappedComponent: emailcampaignEditor});
